/**
 * Intro Slide Information Content
 * 
 * Content for info modals displayed when users click the info icons
 * next to intro slide checkboxes in Collection Settings.
 */

export const introSlideInfo = {
  coverPage: {
    title: 'Cover Page',
    description: 'This slide introduces the brand and collection at a glance. It displays the brand name, collection name, and a simple subtitle ("Product Knowledge").'
  },
  brandIntro: {
    title: 'Brand Introduction',
    description: `Generates a high-level introduction to the brand, tailored for retail training. This slide includes:

• Core brand identity and positioning
• What makes the brand unique or differentiated
• Key facts that help understand the brand's essence
• A concise overview of brand DNA (not full history)`
  },
  brandHistory: {
    title: 'Brand History',
    description: `Provides a focused narrative of the brand's origins and evolution. Content may include:

• Founder background & founding story
• Key milestones and signature aesthetics
• How the brand has evolved culturally or creatively
• Important production or craftsmanship details
• Current market presence or global footprint
• A clear takeaway about the brand's heritage`
  },
  brandPersonality: {
    title: 'Brand Personality',
    description: `Summarizes the emotional and cultural traits that define the brand's personality and "voice". This may include:

• 3–5 key traits (e.g., bold, minimal, rebellious, refined)
• Short explanations connecting each trait to the brand's creative direction or cultural inspiration
• A relevant quote or reference if one authentically exists`
  },
  brandValues: {
    title: 'Brand Values',
    description: `Highlights the brand's 3-5 core values with short explanations. Useful for internalizing what the brand stands for. This may include:

• Value headline (e.g., "Craftsmanship", "Innovation")
• 1–2 sentences on how each value appears in the brand's products, culture, or philosophy`
  },
  collectionIntro: {
    title: 'Collection Introduction',
    description: `Generates an introduction to this specific collection, pulling from any uploaded collection context documents (press releases, creative direction briefs, etc.). This slide may include:

• The collection's story and creative inspiration
• Color palette and key prints or patterns
• Defining silhouettes and design themes
• Notable pieces or highlights from the collection

This slide is most effective when you've uploaded collection context documents in the Collection Info tab.`
  },
  coreCollections: {
    title: 'Core Collections & Signature Categories',
    description: `Breaks down the brand's 3–6 most important product categories. For each category, the slide may include:

• A short headline (category name)
• 1–2 sentences explaining why it is central to the brand
• Key materials, craftsmanship, or symbolic meaning
• Notes on iconic staples when genuinely relevant

Gives a clear understanding of what the brand is best known for and what customers expect.`
  },
  flagshipStores: {
    title: 'Flagship Stores & Experiences',
    description: `Showcases the brand's most iconic retail environments. Depending on the brand, this slide may feature:

• Major flagship or concept stores
• Architectural or design signatures
• Unique customer experiences
• Symbolic meaning or cultural significance
• Notable pop-ups or digital retail experiences
• Localization-aware details (e.g., China- or region-specific activations if the user selects that market)`
  }
};

export default introSlideInfo;
